module.exports = __webpack_public_path__ + "img/m_brandbg.13c97c40.jpg";